import FolderPaywallLayout from './FolderPaywallLayout';
import FolderPaywallLayoutContainer from './FolderPaywallLayout.container';

export default FolderPaywallLayoutContainer(FolderPaywallLayout);
